"use client";
import React, { useState, useId, useEffect } from "react";
import PropTypes from "prop-types";

import { RadioGroup } from "@headlessui/react";

import styles from "./styles.module.css";

const RadioGroups = ({ property, onChange, selected }) => {
  const [selectedOptions, setSelectedOptions] = useState(selected || {});

  const id = useId();

  const handleOptionChange = (selected) => {
    setSelectedOptions(selected);
    onChange && onChange(selected, property?.key);
  };

  useEffect(() => {
    setSelectedOptions(selected);
  }, [selected]);

  return (
    <div className={styles.wrapper}>
      <RadioGroup value={selectedOptions} onChange={(selected) => handleOptionChange(selected)}>
        {property?.config?.values.map((item, index) => (
          <RadioGroup.Option key={`${id}+${index}`} value={item}>
            {({ active, checked }) => (
              <span className={styles.radioWrapper}>
                <div className={styles.display}>{checked && <span className={styles.displayChecked}></span>}</div>
                <RadioGroup.Label as="p" className={styles.title}>
                  {item.name}
                </RadioGroup.Label>
              </span>
            )}
          </RadioGroup.Option>
        ))}
      </RadioGroup>
    </div>
  );
};

RadioGroups.propTypes = {
  property: PropTypes.object,
  onChange: PropTypes.func,
  selected: PropTypes.object,
};

export default RadioGroups;
